import React from "react";
import { connect } from "react-redux";
import { func, string, bool } from "prop-types";
import { push } from "react-router-redux";
import jwtDecode from "jwt-decode";
import { Row, Col, OverlayTrigger, Popover } from "react-bootstrap";
import CriteriaLogo from "resources/images/Criteria-Logo.png";
import CriteriaBlueLogoSmall from "resources/images/Criteria-Logo-Blue-Small.png";
import PartnersLoginForm from "./PartnersLoginForm";
import ForgotPasswordForm from "./ForgotPasswordForm";
import PartnersResetPasswordForm from "./PartnersResetPasswordForm";
import PartnersSuccessPage from "./PartnersSuccessPage";
import { partnersForgotPassword } from "../actions";

// eslint-disable-next-line react/prefer-stateless-function
export class PartnersLoginPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      expiredToken: false,
      status: "login",
    };
  }

  UNSAFE_componentWillMount() {
    localStorage.clear();
    try {
      const token = jwtDecode(this.props.tk2);
      const isExpired = token.exp <= Math.floor(Date.now() / 1000);
      this.setState({ expiredToken: isExpired });
    } catch (e) {
      this.setState({ expiredToken: false });
    }
  }

  showLoginForm = () => {
    this.setState({ status: "login" });
    if (this.props.tk1 && this.props.tk2) {
      this.props.dispatch(push("/partners"));
    }
  };

  showResetPasswordForm = () => {
    this.setState({ status: "resetPassword" });
  };

  render() {
    let ComponentToDisplay;
    if (this.props.tk1 && this.props.tk2) {
      ComponentToDisplay = (
        <PartnersResetPasswordForm
          tk1={this.props.tk1}
          tk2={this.props.tk2}
          showLoginForm={this.showLoginForm}
          showResetPasswordForm={this.showResetPasswordForm}
        />
      );
    } else if (this.state.status === "resetPassword") {
      ComponentToDisplay = (
        <ForgotPasswordForm
          showLoginForm={this.showLoginForm}
          onPartnersForgotPassword={this.props.onPartnersForgotPassword}
        />
      );
    } else if (this.props.partnersResetPassword) {
      ComponentToDisplay = <PartnersSuccessPage />;
    } else if (this.state.status === "login" || this.state.expiredToken) {
      ComponentToDisplay = (
        <PartnersLoginForm
          showResetPasswordForm={this.showResetPasswordForm}
          partnersResetEmailSent={this.props.partnersResetEmailSent}
        />
      );
    }

    return (
      <div style={{ height: "100vh" }}>
        <Row className="h-100 mr-0">
          <Col
            lg={4}
            md={12}
            sm={12}
            className="loginLeftPanel d-none d-lg-block"
          >
            <table>
              <tbody>
                <tr>
                  <td className="align-middle">
                    <img src={CriteriaLogo} alt="Criteria" />
                    <hr color="#d8d8d8" width="65px" />
                    <p
                      style={{
                        color: "#fff",
                        fontSize: "16px",
                        fontWeight: 500,
                      }}
                    >
                      Partner Login
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>
          <Col lg={8} md={12} sm={12} className="loginRightPanel">
            <Row className="mx-0">
              <Col lg={12} md={12} sm={12} className="align-left px-0">
                <div
                  className="d-block d-lg-none"
                  style={{ marginBottom: "-45px" }}
                >
                  <img
                    src={CriteriaBlueLogoSmall}
                    alt="Criteria"
                    className="mt-3"
                  />
                </div>
              </Col>
            </Row>
            <Row
              className="justify-content-center align-items-center"
              style={{ height: "90vh", marginTop: "45px" }}
            >
              <Col lg={6} md={6} sm={6} xs={8} className="pl-0 pr-0">
                {ComponentToDisplay}
              </Col>
            </Row>
            <Row>
              <Col className="loginPageFooter">
                <span>
                  Copyright &copy; 2005-{new Date().getFullYear()}, Criteria
                  Corp. All Rights Reserved. |{" "}
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Popover
                        id="copyrightPopover"
                        style={{
                          padding: "5px 10px",
                        }}
                      >
                        On-Demand Assessment&trade; and Criteria Corp&trade; are
                        trademarks of Criteria Corp. MRAB copyright &copy;2006
                        Harvard University (patent pending) is licensed
                        exclusively by Criteria Corp.
                      </Popover>
                    }
                  >
                    <span className="copyright">Copyright Notices</span>
                  </OverlayTrigger>{" "}
                  |{" "}
                  <a
                    href="https://www.criteriacorp.com/terms-use"
                    target="_blank"
                  >
                    Terms of Use
                  </a>{" "}
                  |{" "}
                  <a
                    href="https://www.criteriacorp.com/privacy-policy"
                    target="_blank"
                  >
                    Privacy Policy
                  </a>{" "}
                  | <a href="/">Criteria Login</a>
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

PartnersLoginPage.propTypes = {
  onPartnersForgotPassword: func.isRequired,
  tk1: string,
  tk2: string,
  partnersResetEmailSent: bool,
  partnersResetPassword: bool,
  dispatch: func,
};

const mapStateToProps = (state) => ({
  showPartnersNewPasswordErrorMessage: state
    .get("App")
    .get("showPartnersNewPasswordErrorMessage"),
  partnersNewPasswordErrorMessage: state
    .get("App")
    .get("partnersNewPasswordErrorMessage"),
  partnersResetEmailSent: state.get("App").get("partnersResetEmailSent"),
  partnersResetPassword: state.get("App").get("partnersResetPassword"),
});

export function mapDispatchToProps(dispatch) {
  return {
    onPartnersForgotPassword: (formData) =>
      dispatch(partnersForgotPassword(formData)),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PartnersLoginPage);
